


function show_error(notify, from, text) {

   // Unauthorized access
   if (text.errors && text.errors[0].message == "E_UNAUTHORIZED_ACCESS: Unauthorized access") {
      window.location.replace('/#/logout')
      return "Произошла ошибка при попытке авторизации. Попробуйте выйти и зайти еще раз";
   }
   // Validator error, show in from 
   if (from && typeof text.errors != 'undefined') {
      let errors = text.errors;
      let resp = [];
      for (let i = 0; i < errors.length; i++) {
         resp[errors[i].field] = errors[i].message
      }
      from.setErrors(resp)
      return;
   }
   if (!from && typeof text.errors != 'undefined') {
      console.log('text.errors[0]', text.errors[0].message)
      notify({
         group: "bottom-right",
         title: "Ошибка",
         type: "warn",
         text: text.errors[0].message
      });
      return;
   }

   // Just notification
   notify({
      group: "bottom-right",
      title: "Ошибка",
      type: "warn",
      text: text
   });
}

function show_message(notify, text) {
   notify({
      group: "bottom-right",
      title: "Сообщение",
      type: "info",
      text: text
   });
}

export { show_message, show_error };
